
const singal = resolve => require(['@/components/ordering/singal'],resolve);
const batch = resolve => require(['@/components/ordering/batchOrder/index'],resolve);
const match = resolve => require(['@/components/ordering/match'],resolve);
const infer = resolve => require(['@/components/ordering/infer'],resolve);
const inferControl = resolve => require(['@/components/ordering/inferControl'],resolve);
const deduceList = resolve => require(['@/components/ordering/deduceList'],resolve);
const deduceDetail = resolve => require(['@/components/ordering/deduceDetail'],resolve);
export default [
	{
		path : 'ordering/singal',
		name : 'orderingSingal',
		meta : {
			title : '单款订货',
			mainSearchHandle (){

			}
		},
		component : singal
	},
	{
		path : 'ordering/batch',
		name : 'orderingBatch',
		meta : {
			title : '批量订货',
			searchDisabled : false,
		},
		component : batch
	},
	{
		path : 'ordering/match',
		name : 'orderingMatch',
		meta : {
			title : '搭配订货',
			mainSearchHandle (){

			}
		},
		component : match
	},
	{
		path : 'ordering/infer',
		name : 'orderingInfer',
		meta : {
			title : '推送订货',
			mainSearchHandle (){

			},
			notNeedGlobalScroll : true,
			searchDisabled : true
		},
		component : infer
	},
	{
		path : 'ordering/inferControl',
		name : 'orderingInferControl',
		meta : {
			title : '推送订货',
			mainSearchHandle (){

			},
			notNeedGlobalScroll : true,
			searchDisabled : false,
			activeName : 'orderingInfer'
		},
		component : inferControl
	},
	{
		path : 'ordering/deduceList',
		name : 'orderingDeduceList',
		meta : {
			title : '360推演列表',
			mainSearchHandle (){

			},
		},
		component : deduceList
	},
	{
		path : 'ordering/deduceDetail',
		name : 'orderingDeduceDetail',
		meta : {
			title : '360推演详情',
			mainSearchHandle (){

			},
			activeName : 'orderingDeduceList',
		},
		component : deduceDetail
	},
]



// WEBPACK FOOTER //
// ./src/router/ordering/index.js